import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import Button, { ButtonProps } from '../Button'
import { ButtonVariant } from '../types'

const BackButton = (props: ButtonProps) => (
  <Button variant={ButtonVariant.Back} {...props} startIcon={<ArrowBackIcon />} />
)

export default BackButton
